import { ReactComponent as BlockedAlarmIcon } from '../../../assets/imgs/chats/blocked-alarm-banner-icon.svg';
import { Callout } from '../../Callout';
import { palette } from '../../../theme/colors';
import { translate } from '../../../utils/translate';
import {
  Body,
  CalloutWrapper,
  Container,
  IconCircle,
  Spacer,
  Title,
} from './SilentModeBlockedView.styles';

type SilentModeBlockedViewProps = {
  alarmName: string | null;
};

export const SilentModeBlockedView = ({ alarmName }: SilentModeBlockedViewProps) => (
  <Container role="silentModeBlockedView">
    <IconCircle>
      <BlockedAlarmIcon fill={palette.gold} />
    </IconCircle>
    <Title>{translate('test_alarm_silent_mode_title')}</Title>
    <Body>
      {alarmName
        ? translate('test_alarm_silent_mode_body', { alarmName })
        : translate('test_alarm_silent_mode_body_no_name')}
    </Body>
    <CalloutWrapper>
      <Callout
        labelTx="test_alarm_silent_mode_when_label"
        bodyTx="test_alarm_silent_mode_when_body"
      />
    </CalloutWrapper>
    <Spacer />
  </Container>
);
